import { CustomPortableText } from 'shared/studio/PortableText';
import { EduArticlePortableTextProps } from 'types/studio/eduHub';
import styles from './EduArticlePortableText.module.scss';

export const EduArticlePortableText = ({
  portableText,
  tableOfContentsHeadlines,
  _key: key
}: EduArticlePortableTextProps) => (
  <>
    {tableOfContentsHeadlines &&
      tableOfContentsHeadlines.map((tocItem) => (
        <CustomPortableText
          value={tocItem.portableText}
          className={styles.text}
          // eslint-disable-next-line no-underscore-dangle
          id={tocItem._id}
          key={`${key}`}
          tag={tocItem?.portableText[0]?.style || 'normal'}
        />
      ))}
    {portableText && <CustomPortableText value={portableText} className={styles.text} />}
  </>
);
